import { Component, EventEmitter, Inject, Input, Output } from '@angular/core';

import { ApplicationFacade } from '@ridango/components';
import { Organization } from '@ridango/components/lib/corporate-employees/corporate-employees.models';
import Env from '@ridango/core/env';
import { AppStartupService } from '@ridango/core';

@Component({
    selector: 'gl-shopping-cart-company',
    templateUrl: './shopping-cart-company.component.html',
    styleUrls: ['./shopping-cart-company.component.scss']
})
export class ShoppingCartCompanyComponent {
    @Input() organization: Organization;
    @Input() selectedCompany: Organization;
    @Input() disabled = false;
    @Output() organizationSelected = new EventEmitter<Organization>();
    public assetsPath$ = this.applicationFacade.assetsPath$;
    currency = this.appStartupService.getCurrency();
    isContrast$ = this.applicationFacade.highContrast$;

    constructor(
        private applicationFacade: ApplicationFacade,
        @Inject('ENV') public env: Env,
        public appStartupService: AppStartupService
    ) {}
}
